// Content is rendered by the parent route via FilterTabs
<template></template>
